export default "__VITE_ASSET__DxL_LCrI__"